// eslint-disable-next-line no-unused-vars
import React from 'react';
import { renderRoutes } from 'react-router-config';
import 'semantic-ui-css/semantic.css';
import './App.css';
import routes from '../../routes';

const App = () => renderRoutes(routes);

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.js